import React from 'react'

function AdminPunishHistory() {
  return (
   <>
   <div className="main-container">
  <div className="pd-ltr-20 xs-pd-20-10">
    <div className="min-height-200px">
      <div className="page-header">
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="title">
              <h4>Punishments</h4>
            </div>
            <nav aria-label="breadcrumb" role="navigation">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/admindashboard">Home</a>
                </li>
                <li className="breadcrumb-item">
                  Punishments
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Punishment History
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      {/* Simple Datatable start */}
      <div className="card-box mb-30">
        <div className="pd-20">
          <h4 className="text-blue h4">Recent Punishments</h4>
        </div>
        <div className="pb-20">
          <table className="data-table datatable-nosort  table table-responsive-lg stripe hover">
            <thead className='thead-dark'>
              <tr>
                <th className="table-plus datatable-nosort">Teacher ID</th>
                <th >Teacher Name</th>
                <th >School</th>
                <th >District</th>
                <th >State</th>
                <th >Type of Punishment</th>
                <th >Reason</th>
                <th className="datatable-nosort">Action</th>
              </tr>
            </thead>
            <tbody>
              
              
              <tr>
                <td className="table-plus">198233</td>
                <td>XYZ</td>
                <td>ZPHS</td>
                <td>Rangareddy</td>
                <td>Telangana</td>
                <td>Suspension</td>
                <td>Illegal activity</td>
                <td>
                    <a
                      className="btn btn-link font-24 p-0 line-height-1 mt-0 no-arrow"
                      href="#"
                      role="button"
                    >
                      <i className="dw dw-eye" />
                    </a>
                </td>
              </tr>
              
              
              
            </tbody>
          </table>
        </div>
      </div>
      
    </div>

  </div>
</div>
   </>
  )
}

export default AdminPunishHistory